(function (runtime) {
  var constants = {
    classNames: {
      responsive: "ixp-component-pdf-viewer--responsive",
      loading: "ixp-component-pdf-viewer--loading",
      error: "ixp-component-pdf-viewer--error",
      fadeout: "ixp-component-pdf-viewer--fadeout",
    },
    cssAttributes: {
      height: "--height",
      width: "--width",
    },
  };

  runtime.components.register("ixp-pdf-viewer", {
    initialize: function (options) {
      if (this.inStudio) return;

      var _self = this;
      var _rootEl = _unwrapJQuery(_self.$el);

      if (!this.action) {
        _rootEl.prepend("<div>No PDF provided</div>");
      }

      _rootEl.classList.toggle(
        constants.classNames.responsive,
        this.responsive
      );

      if (!this.responsive) {
        _rootEl.style.setProperty(constants.cssAttributes.height, this.height);
        _rootEl.style.setProperty(constants.cssAttributes.width, this.width);
      }

      var ifrm = document.createElement("iframe");
      _self._pdfIframe = ifrm;

      var loadPromise = new Promise(function (resolve, reject) {
        function cleanup() {
          ifrm.removeEventListener("load", handleLoad);
          ifrm.removeEventListener("error", handleError);
          _self._pdfLoadCleanup = null;
        }
        function handleLoad(event) {
          cleanup();
          resolve(event);
        }
        function handleError() {
          cleanup();
          reject(new Error("Unable to display PDF"));
        }
        _self._pdfLoadCleanup = cleanup;
        ifrm.addEventListener("load", handleLoad);
        ifrm.addEventListener("error", handleError);
      });

      _rootEl.classList.add(constants.classNames.loading);

      fetch(this.action)
        .then(function (response) {
          // Throw error when the response starts with 4XX or 5XX
          if (("" + response.status).match(/^[45][0-9][0-9]$/))
            throw new Error(
              "[HTTP " +
                response.status +
                "] " +
                response.statusText +
                ": " +
                response.url
            );

          return response.blob();
        })
        .then(function (blob) {
          if (_self._pdfDestroyed) return;

          _self._pdfObjectUrl = URL.createObjectURL(blob);
          ifrm.src = _self._pdfObjectUrl;
          // append iframe to DOM so it triggers the load event
          _rootEl.prepend(ifrm);

          return loadPromise;
        })
        .catch(function (ex) {
          if (_self._pdfDestroyed) return;
          if (_self._pdfLoadCleanup) _self._pdfLoadCleanup();
          if (_self._pdfObjectUrl) {
            URL.revokeObjectURL(_self._pdfObjectUrl);
            _self._pdfObjectUrl = null;
          }
          // In case any of the promises fails Show the thrown error message
          var span = document.createElement("span");
          span.innerText = ex;
          _rootEl.prepend(span);
          _rootEl.classList.add(constants.classNames.error);
        })
        .finally(function () {
          if (_self._pdfDestroyed) return;
          // In any case remove the loading spinner
          function loadingTransitionEnd(event) {
            _rootEl.removeEventListener("transitionend", loadingTransitionEnd);
            _rootEl.classList.remove(constants.classNames.loading);
            _rootEl.classList.remove(constants.classNames.fadeout);
          }
          _rootEl.addEventListener("transitionend", loadingTransitionEnd);

          _rootEl.classList.add(constants.classNames.fadeout);
        });
    },
    onDestroy: function () {
      this._pdfDestroyed = true;
      if (this._pdfLoadCleanup) this._pdfLoadCleanup();
      if (this._pdfIframe) {
        this._pdfIframe.remove();
        this._pdfIframe = null;
      }
      if (this._pdfObjectUrl) {
        URL.revokeObjectURL(this._pdfObjectUrl);
        this._pdfObjectUrl = null;
      }
    },
    getParamMapOverrides: function () {
      return {
        responsive: function (val) {
          this.responsive = val === true || val === "true";

          var _rootEl = _unwrapJQuery(this.$el);
          _rootEl.classList.toggle(
            constants.classNames.responsive,
            this.responsive
          );
        },
        height: function (val) {
          this.height = val || 406;
          if (!this.responsive) {
            var _rootEl = _unwrapJQuery(this.$el);
            _rootEl.style.setProperty(
              constants.cssAttributes.height,
              this.height
            );
          }
        },
        width: function (val) {
          this.width = val || 314;
          if (!this.responsive) {
            var _rootEl = _unwrapJQuery(this.$el);
            _rootEl.style.setProperty(
              constants.cssAttributes.width,
              this.width
            );
          }
        },
      };
    },
    // studio
    onGetScaffolding: function (scaffoldingKey, builder, options) {
      return { scaffolding: [builder.scaffoldContainer("PDF Viewer")] };
    },
    allowedDropTargets: function () {
      return ['Container', 'Column'];
    },
  });

  function _unwrapJQuery($el) {
    return $el.get(0);
  }
})(window.ixp.runtime);
